import "./Minute.css";
import { CSSProperties, useContext } from "react";
import { usePreference } from "../../../context/usePreference";
import { getDataObjArray } from "../Sidebar/SideBarUtils";
import { getCSSPropertiesHeight, renderTableFirstGrid } from "./MinuteUtils";
import { UiContext } from "../../../context/UiContext";

export function MinuteTableRowFirst({ rowContent, rowID }) {
  const row = rowContent;
  const u = usePreference();
  const Indice = u.userPreference?.Indice;
  const { userPreference, userTarget } = usePreference();
  const { isMobile } = useContext(UiContext);

  const Target = userPreference.Praca?.Targets?.find(
    (target) => target.Id === userTarget.Target?.Id
  ) ?? userPreference.Praca?.Targets?.[0];

  let classColor = rowID % 2 === 0 ? "tableRow" : "tableRow even";

  if (rowContent[2] == "" || rowContent[3] == 0) {
    classColor = "tableRowAlert";
  } else if (parseInt(rowContent[0]) === 1) {
    classColor += " type1";
  } else if (parseInt(rowContent[0]) === 2) {
    classColor += " type2";
  }

  classColor += Indice > 2 ? " dobleIndice" : "";

  const rowHeight: CSSProperties = {
    ...getCSSPropertiesHeight(u.userPreference?.TipoBase, Indice),
    borderTop: isMobile ? "1px solid #000" : "none"
  };
  if (u.userPreference?.TipoBase === 0) {
    return (
      <tr className={classColor} style={rowHeight}>
        {renderTableFirstGrid(row, rowContent, Target.Id)}
      </tr>
    );
  } else {
    let rowFiltred = getDataObjArray(row)?.filter(function (val, rowID) {
      return rowID === 1 || rowID === 2;
    });

    return (
      <tr className={classColor} style={rowHeight}>
        {rowContent[2] == "" || rowContent[3] == 0 ? (
          getDataObjArray(row).map(
            (val, rowID) =>
              rowID === 1 && (
                <td
                  key={val.ValueId}
                >
                  <span
                    style={{
                      color: "#D1A800",
                      fontSize: "14px",
                      marginRight: "5px",
                    }}
                  >
                    <i
                      className="header-icon-13"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </span>

                  {val.DataValueArray}
                </td>
              )
          )
        ) : (
          <td colSpan={1} style={{ borderRight: "1px solid #fff" }}>
            <div className="divfirstRow">
              <tr style={{ color: "white", textAlign: "center", fontSize: "20px" }} key={rowID}>
                {rowFiltred[0].DataValueArray}
              </tr>
              <tr style={{ textAlign: "center", color: "black" }}>
                <p style={{ margin: "0px" }}>
                  <i
                    className={"header-icon-" + Target?.Id}
                    style={{ fontSize: "12px" }}
                  ></i>
                  <span style={{ color: "white", fontSize: '20px' }}>
                    {rowFiltred[1].DataValueArray}
                  </span>
                </p>
              </tr>
            </div>
          </td>
        )
        }
      </tr >
    );
  }
}
